<template>
  <Card>
    <template #content>
      <div class="container">
        <div>
          <span class="card-field">
            <span class="material-icons">person</span>
            <p>{{ formatted.name }}</p>
          </span>
        </div>
        <div>
          <span class="card-field">
            <span class="material-icons">assignment</span>
            <p>{{ formatted.document }}</p>
          </span>
        </div>
        <div>
          <div class="card-field">
            <span><IconPhone></IconPhone></span>
            <p>{{ formatted.phone }}</p>
          </div>
        </div>
        <div>
          <div class="card-field">
            <span><IconInfo></IconInfo></span>
            <p>{{ formatted.accepted }}</p>
          </div>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import IconInfo from '../../../components/icon/IconInfo.vue';
import IconPhone from '../../../components/icon/IconPhone.vue';

export default {
  name: 'VetCustomerCard',
  props: {
    model: Object,
  },
  components: {
    IconPhone,
    IconInfo,
  },
  computed: {
    formatted() {
      const data = {
        name: this.model.account.name || '-',
        document: this.$formatDocument(this.model.account.document) || '-',
        phone: this.$formatPhone(this.model.account.phone) || '-',
        accepted: this.model.accepted
          ? 'Aceitado'
          : 'Aceite pendente',
      };
      return data;
    },
  },
};
</script>

<style scoped>
.container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas: '. . . .';
}
/* Content */
div >>> .p-card-content {
  padding: 0 !important;
}
.card-field p {
  display: inline-block;
  vertical-align: top;
  padding-top: 2px;
}
.card-field span {
  padding-right: 10px;
}
</style>